module.exports = __webpack_public_path__ + "static/media/05.10320140.mp3";